<template>
  <div class="lines-block overflow-auto pr-1" v-once>
    <div class="line-header-wrapper">
      <div class="date-text">
        {{ 'Date' | i18n }}
      </div>
      <div>
        {{ 'Comment' | i18n }}
      </div>
    </div>
    <div v-for="row in yearData.days" :key="row.date" class="line-wrapper">
      <div class="date-text">
        {{ moment(row.date).format('DD-MM-YYYY') }}
        {{ moment(row.date).format('ddd') | i18n }}
      </div>
      <div class="textarea-block">
        <Textarea
          v-model="row.comment"
          :on-change="(v) => setBackendData(v, 'comment', row.date)"
          :placeholder="'Comment' | i18n"
        />
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

import Textarea from '../../common/textarea';

export default {
  title: 'TableLogBook',
  components: { Textarea },
  props: {
    yearData: {
      type: Object,
      default: () => {},
    },
    setBackendData: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      moment: moment,
      typeOptions: ['', 'f', 'm'],
    };
  },
};
</script>

<style scoped lang="scss">
.line-header-wrapper {
  display: flex;
  background: rgb(247, 247, 249);
  position: sticky;
  top: 0;
  z-index: 1000;
  margin-bottom: 30px;
  div {
    display: flex;
    align-items: center;
    background: #f7f7f9;
  }
}

.line-wrapper {
  display: flex;
}

.date-text {
  min-width: 150px;
  width: 150px;
  padding: 0 5px;
}

.textarea-block {
  width: 100%;
}
</style>
